// src/hooks/useLargeurElement.ts — SCE Issues
// Largeur utile d'un élément (hors barre de défilement), suivie quand la fenêtre
// ou la page change. Sert à répartir les colonnes du tableau.

import { useEffect, useState, type RefObject } from 'react'

export function useLargeurElement(ref: RefObject<HTMLElement>): number {
  const [largeur, setLargeur] = useState(0)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const lire = (): void => setLargeur(el.clientWidth)
    lire()
    const observateur = new ResizeObserver(lire)
    observateur.observe(el)
    return () => observateur.disconnect()
  }, [ref])

  return largeur
}
